var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        { ref: "form", attrs: { model: _vm.model, rules: _vm.validatorRules } },
        [
          _c(
            "a-row",
            { staticStyle: { width: "100%", border: "2px" } },
            [
              _c(
                "div",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["user.column.Avatar"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: _vm.language["common.uploadButton"],
                              "upload-source": "platform"
                            },
                            model: {
                              value: _vm.model.avatar,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "avatar", $$v)
                              },
                              expression: "model.avatar"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.userType === "nonemployee"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["user.column.userAccount"],
                                prop: "username",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: this.language[
                                    "warning.userAccountRequired"
                                  ],
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.model.username,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "username", $$v)
                                  },
                                  expression: "model.username"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.userType === "employee"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["column.jobNumber"],
                                prop: "workNo",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: this.language[
                                    "portal.front.please.number"
                                  ],
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.model.workNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "workNo", $$v)
                                  },
                                  expression: "model.workNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        prop: "realname",
                        label: this.language["portal.front.realname"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: this.language[
                            "portal.front.input.realname"
                          ],
                          disabled: _vm.disabled,
                          maxLength: _vm.maxLength
                        },
                        model: {
                          value: _vm.model.realname,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "realname", $$v)
                          },
                          expression: "model.realname"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.userType === "employee"
                ? _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["employee.column.englishName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { type: "text", maxLength: 40 },
                            model: {
                              value: _vm.model.englishName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "englishName", $$v)
                              },
                              expression: "model.englishName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                [
                  _vm.userType === "employee"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["portal.front.factory"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "siteCode"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  type: "text",
                                  maxLength: _vm.maxLength,
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.model.factoryName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "factoryName", $$v)
                                  },
                                  expression: "model.factoryName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.userType === "employee"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["portal.front.join.date"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "joinDate"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  type: "text",
                                  maxLength: _vm.maxLength,
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.model.joinDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "joinDate", $$v)
                                  },
                                  expression: "model.joinDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.userType === "employee"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["user.column.birthday"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "joinDate"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  type: "text",
                                  maxLength: _vm.maxLength,
                                  disabled: _vm.disabled
                                },
                                model: {
                                  value: _vm.model.birthday,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "birthday", $$v)
                                  },
                                  expression: "model.birthday"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.userType === "employee"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["businessGroupName"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "bg"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  type: "text",
                                  placeholder:
                                    _vm.language["ad.must"] +
                                    " " +
                                    _vm.language["businessGroupName"]
                                },
                                model: {
                                  value: _vm.model.bg,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "bg", $$v)
                                  },
                                  expression: "model.bg"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.userType === "employee"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["businessUnitName"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "bu"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  type: "text",
                                  placeholder:
                                    _vm.language["ad.must"] +
                                    " " +
                                    _vm.language["businessUnitName"]
                                },
                                model: {
                                  value: _vm.model.bu,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "bu", $$v)
                                  },
                                  expression: "model.bu"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.userType === "employee"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["portal.personalOrgCode"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "departName"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  type: "text",
                                  placeholder:
                                    _vm.language["ad.must"] +
                                    " " +
                                    _vm.language["portal.personalOrgCode"]
                                },
                                model: {
                                  value: _vm.model.departName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "departName", $$v)
                                  },
                                  expression: "model.departName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["column.gender"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "sex"
                          }
                        },
                        [
                          _c("JDictSelectTag", {
                            staticStyle: { size: "100px" },
                            attrs: { type: "radio", dictCode: "sex" },
                            model: {
                              value: _vm.model.sex,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sex", $$v)
                              },
                              expression: "model.sex"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.userType === "nonemployee"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["common.company"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.model.companyName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "companyName", $$v)
                                  },
                                  expression: "model.companyName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["column.Landline"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        prop: "1"
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          type: "text",
                          placeholder:
                            _vm.language["ad.must"] +
                            " " +
                            _vm.language["column.Landline"],
                          maxLength: _vm.maxLength
                        },
                        model: {
                          value: _vm.model.telephone,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "telephone", $$v)
                          },
                          expression: "model.telephone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _vm.userType === "employee"
                    ? _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["column.mailbox"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "email"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              type: "text",
                              placeholder: this.language[
                                "warning.emailRequired"
                              ],
                              maxLength: 50
                            },
                            model: {
                              value: _vm.model.email,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "email", $$v)
                              },
                              expression: "model.email"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["column.mailbox"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              type: "text",
                              placeholder: this.language[
                                "warning.emailRequired"
                              ],
                              maxLength: 50
                            },
                            model: {
                              value: _vm.model.email,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "email", $$v)
                              },
                              expression: "model.email"
                            }
                          })
                        ],
                        1
                      )
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: this.language["column.cellphoneNumber"],
                        prop: "phone",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c(
                        "a-input",
                        {
                          attrs: {
                            type: "text",
                            autocomplete: "false",
                            placeholder: this.language["warning.phoneRequired"],
                            maxLength: 20,
                            disabled: _vm.userType === "nonemployee"
                          },
                          model: {
                            value: _vm.model.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "phone", $$v)
                            },
                            expression: "model.phone"
                          }
                        },
                        [
                          _c("a-icon", {
                            style: { color: "rgba(0,0,0,.25)" },
                            attrs: { slot: "prefix", type: "phone" },
                            slot: "prefix"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.userType === "employee"
                ? _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["PlatForm.employee.columns.address"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { type: "text", maxLength: 100 },
                            model: {
                              value: _vm.model.address,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "address", $$v)
                              },
                              expression: "model.address"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }